import { render } from "./AccountStatus.vue?vue&type=template&id=85e6a3de&scoped=true"
import script from "./AccountStatus.vue?vue&type=script&lang=js"
export * from "./AccountStatus.vue?vue&type=script&lang=js"

import "./AccountStatus.vue?vue&type=style&index=0&id=85e6a3de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e6a3de"]])

export default __exports__